module.exports = __webpack_public_path__ + "static/img/qualifications_row_8.1a2e052.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_8.png
// module id = ypnn
// module chunks = 1